import React from 'react';
import styled from 'styled-components';
import {InviteUserIcon} from '../../UI/Icons';
import {motion} from 'framer-motion';
import {setShowInvitePopup} from './inviteSlice';
import {useDispatch} from 'react-redux';


const StyledBtn = styled(motion.button)`
  padding: 0;
  width: 56px;
  height: 56px;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
  cursor: pointer;
`


const InviteButton = () => {
    const dispatch = useDispatch();

    return (
        <StyledBtn whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} onClick={() => dispatch(setShowInvitePopup(true))} id='continue-button'>
            {InviteUserIcon}
        </StyledBtn>
    )
};


export default InviteButton;